import { render, staticRenderFns } from "./box_2.vue?vue&type=template&id=63b47f69&scoped=true&"
import script from "./box_2.vue?vue&type=script&lang=js&"
export * from "./box_2.vue?vue&type=script&lang=js&"
import style0 from "./box_2.vue?vue&type=style&index=0&id=63b47f69&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63b47f69",
  null
  
)

export default component.exports